(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wellbeing-cart"]) return;
  try {
    
(function () {
  var pendingUpdate;
  document.addEventListener('click', function (event) {
    var button = event.target.closest('#WellbeingCart [data-quantity-change]');
    if (!button) return;
    var input = button.parentElement.querySelector('input[type="number"]');
    input.value = Math.max(0, (parseInt(input.value, 10) || 0) + Number(button.dataset.quantityChange));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches('#WellbeingCart input[name="updates[]"]')) return;
    var form = input.form;
    clearTimeout(pendingUpdate);
    if (!input.checkValidity()) { input.reportValidity(); return; }
    pendingUpdate = setTimeout(function () {
      form.requestSubmit(form.querySelector('[name="update"]'));
    }, 550);
  });
  document.addEventListener('submit', function (event) {
    if (event.target.id !== 'WellbeingCart') return;
    clearTimeout(pendingUpdate);
    event.target.setAttribute('aria-busy', 'true');
    event.target.querySelectorAll('[data-quantity-change]').forEach(function (button) { button.disabled = true; });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellbeing-collection"]) return;
  try {
    
document.querySelectorAll('.wb:not([data-discount-listing]) .wb-collection-sort').forEach(function(form){form.classList.add('wb-auto-sort');form.querySelector('select[name="sort_by"]').addEventListener('change',function(){form.requestSubmit();});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellbeing-header"]) return;
  try {
    
document.addEventListener('click',function(e){document.querySelectorAll('.wb-desktop-nav>details[open],.wb-mobile-nav[open],.wb-header-search[open]').forEach(function(d){if(!d.contains(e.target))d.open=false;});});
document.addEventListener('keydown',function(e){if(e.key==='Escape')document.querySelectorAll('.wb-nav details[open]').forEach(function(d){d.open=false;d.querySelector('summary').focus();});});
document.addEventListener('toggle',function(e){if(!e.target.matches('.wb-header-search')||!e.target.open)return;document.querySelectorAll('.wb-desktop-nav>details[open],.wb-mobile-nav[open]').forEach(function(d){d.open=false;});e.target.querySelector('input[type="search"]').focus();},true);
document.addEventListener('click',function(e){var close=e.target.closest('.wb-header-search-close');if(close){var search=close.closest('details');search.open=false;search.querySelector('summary').focus();}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellbeing-products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(e){const button=e.target.closest('[data-wb-prev],[data-wb-next]');if(!button)return;const row=document.getElementById(button.getAttribute('aria-controls'));if(row)row.scrollBy({left:row.clientWidth*(button.hasAttribute('data-wb-prev')?-1:1),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellbeing-recommendations"] && !Shopify.designMode) return;
  try {
    
function loadWellbeingRecommendations(root=document){root.querySelectorAll('[data-wb-recommendations]').forEach(section=>{if(section.dataset.loaded)return;section.dataset.loaded='true';const controller=new AbortController();const timeout=setTimeout(()=>controller.abort(),8000);fetch(section.dataset.url,{signal:controller.signal}).then(response=>{if(!response.ok)throw new Error('Recommendations unavailable');return response.text();}).then(html=>{const doc=new DOMParser().parseFromString(html,'text/html');const grid=doc.querySelector('.wb-related-grid');if(grid&&grid.querySelector('.wb-card'))section.querySelector('.wb-related-grid').replaceChildren(...grid.children);}).catch(()=>{}).finally(()=>clearTimeout(timeout));});}
loadWellbeingRecommendations();document.addEventListener('shopify:section:load',event=>loadWellbeingRecommendations(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellbeing-search"]) return;
  try {
    
document.querySelectorAll('.wb-search-form--curated').forEach(function(form){form.classList.add('wb-enhanced');var select=form.querySelector('select[name="sort_by"]');if(select)select.addEventListener('change',function(){form.requestSubmit();});});

  } catch(e) { console.error(e); }
})();
})();
